module.exports = __webpack_public_path__ + "img/低通3.5ad7eee6.png";